import { useWorkers } from "@/features/team/hooks/use-workers";
import { useMe } from "@/hooks/use-me.ts";

export function useMyMembership() {
	const me = useMe();
	const workers = useWorkers();
	const userId = me.data?.user.id;

	const worker = userId
		? workers.data?.find((item) => item.active && item.userId === userId)
		: undefined;
	const resolved = !!userId && workers.isSuccess;

	return {
		worker,
		isMember: resolved ? !!worker : undefined,
		isLoading: me.isLoading || workers.isLoading,
		isError: me.isError || workers.isError,
	};
}
